/* Kay Galerie · Blatt band. One sheet rolls into Blatt Fuge v3 as the band scrolls in; the cursor turns it a little.
   Shape from a slice of the v3 print file: 8 mm sheet, centre line r = 50 + 20.5 * turn (mm) over 460 degrees, 220 mm tall,
   groove 20 to 26 mm above the rim, 1.5 mm deep, flat top with the socket hole over the hanging axis (9.62, 6.79).
   three.js (theme asset) loads only when the band comes near the screen. */
(function () {
var N = 300, PAPER = 0xFAF8F4, CXH = 9.62, CYH = 6.79;
var HS = [0]; for (var k = 1; k <= 36; k++) HS.push(220 * k / 36); [20, 21.5, 26, 26.05].forEach(function (v) { HS.push(v); }); HS.sort(function (a, b) { return a - b; });
var R = HS.length;
function groove(h) { return (h >= 20 && h < 21.5) ? h - 20 : (h >= 21.5 && h <= 26 ? 1.5 : 0); }
var X = [], Y = [], S = [0], TH = [];
(function () {
  var p1 = 460 * Math.PI / 180, b = 20.5 / (2 * Math.PI), i;
  for (i = 0; i <= N; i++) { var ph = p1 * i / N, r = 50 + b * ph; X.push(r * Math.cos(ph)); Y.push(r * Math.sin(ph)); if (i) S.push(S[i - 1] + Math.hypot(X[i] - X[i - 1], Y[i] - Y[i - 1])); }
  for (i = 0; i <= N; i++) { var a = Math.max(i - 1, 0), z = Math.min(i + 1, N); TH.push(Math.atan2(Y[z] - Y[a], X[z] - X[a])); }
  for (i = 1; i <= N; i++) { while (TH[i] - TH[i - 1] > Math.PI) TH[i] -= 2 * Math.PI; while (TH[i] - TH[i - 1] < -Math.PI) TH[i] += 2 * Math.PI; }
})();

var threeP = null;
function loadThree(src) {
  if (window.THREE) return Promise.resolve();
  if (!threeP) threeP = new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = no; document.head.appendChild(s); });
  return threeP;
}

function skin() {
  var n = 256, c = document.createElement('canvas'); c.width = c.height = n;
  var g = c.getContext('2d'), img = g.createImageData(n, n), h = new Float32Array(n * n), x, y;
  function rnd(i, j) { var v = Math.sin(i * 127.1 + j * 311.7) * 43758.5453; return v - Math.floor(v); }
  function vn(px, py, p) { var xi = Math.floor(px), yi = Math.floor(py), xf = px - xi, yf = py - yi, u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    var a = rnd(xi % p, yi % p), b = rnd((xi + 1) % p, yi % p), cc = rnd(xi % p, (yi + 1) % p), d = rnd((xi + 1) % p, (yi + 1) % p);
    return a + (b - a) * u + (cc - a) * v + (a - b - cc + d) * u * v; }
  for (y = 0; y < n; y++) for (x = 0; x < n; x++) h[y * n + x] = 0.65 * vn(x / 5, y / 5, n / 5) + 0.35 * vn(x / 2, y / 2, n / 2);
  for (y = 0; y < n; y++) for (x = 0; x < n; x++) {
    var hx = h[y * n + (x + 1) % n] - h[y * n + (x - 1 + n) % n], hy = h[((y + 1) % n) * n + x] - h[((y - 1 + n) % n) * n + x];
    var nx = -hx * 2, ny = -hy * 2, l = Math.hypot(nx, ny, 1), i = 4 * (y * n + x);
    img.data[i] = (nx / l * .5 + .5) * 255; img.data[i + 1] = (ny / l * .5 + .5) * 255; img.data[i + 2] = (1 / l * .5 + .5) * 255; img.data[i + 3] = 255;
  }
  g.putImageData(img, 0, 0); var t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; return t;
}

// vertex layout: outer face, inner face, bottom edge, top edge, two ends. Positions rewritten for each curl c.
function sheetGeometry() {
  var nv = 2 * (N + 1) * R + 4 * (N + 1) + 4 * R, pos = new Float32Array(nv * 3), uv = new Float32Array(nv * 2), idx = [], i, j;
  var O = 0, I = (N + 1) * R, B = 2 * I, T = B + 2 * (N + 1), E = T + 2 * (N + 1);
  for (j = 0; j < R - 1; j++) for (i = 0; i < N; i++) {
    var a = j * (N + 1) + i, b = a + 1, c = a + N + 1, d = c + 1;
    idx.push(O + a, O + c, O + b, O + b, O + c, O + d, I + a, I + b, I + c, I + b, I + d, I + c);
  }
  for (i = 0; i < N; i++) {
    idx.push(B + 2 * i, B + 2 * i + 2, B + 2 * i + 1, B + 2 * i + 2, B + 2 * i + 3, B + 2 * i + 1);
    idx.push(T + 2 * i, T + 2 * i + 1, T + 2 * i + 2, T + 2 * i + 2, T + 2 * i + 1, T + 2 * i + 3);
  }
  for (var e = 0; e < 2; e++) for (j = 0; j < R - 1; j++) { var q = E + e * 2 * R + 2 * j; idx.push(q, q + 2, q + 1, q + 2, q + 3, q + 1); }
  for (j = 0; j < R; j++) for (i = 0; i <= N; i++) { var u = (j * (N + 1) + i) * 2; uv[u] = uv[u + 2 * I] = S[i] / 26; uv[u + 1] = uv[u + 1 + 2 * I] = HS[j] / 26; }
  var g = new THREE.BufferGeometry();
  g.setAttribute('position', new THREE.BufferAttribute(pos, 3).setUsage(THREE.DynamicDrawUsage));
  g.setAttribute('uv', new THREE.BufferAttribute(uv, 2)); g.setIndex(idx);
  g.userData = { O: O, I: I, B: B, T: T, E: E };
  return g;
}

function curl(g, c) {
  var m = N >> 1, tc = new Float64Array(N + 1), cx = new Float64Array(N + 1), cy = new Float64Array(N + 1), i, j;
  for (i = 0; i <= N; i++) tc[i] = TH[m] + c * (TH[i] - TH[m]);
  cx[m] = X[m]; cy[m] = Y[m];
  for (i = m + 1; i <= N; i++) { var t = 0.5 * (tc[i] + tc[i - 1]), ds = S[i] - S[i - 1]; cx[i] = cx[i - 1] + ds * Math.cos(t); cy[i] = cy[i - 1] + ds * Math.sin(t); }
  for (i = m - 1; i >= 0; i--) { var t2 = 0.5 * (tc[i] + tc[i + 1]), ds2 = S[i + 1] - S[i]; cx[i] = cx[i + 1] - ds2 * Math.cos(t2); cy[i] = cy[i + 1] - ds2 * Math.sin(t2); }
  var P = g.attributes.position.array, U = g.userData;
  function put(k, px, py, h) { P[3 * k] = (px - CXH) / 100; P[3 * k + 1] = h / 100 - 1.1; P[3 * k + 2] = (py - CYH) / 100; }
  for (j = 0; j < R; j++) for (i = 0; i <= N; i++) {
    var nx = Math.sin(tc[i]), ny = -Math.cos(tc[i]), k = j * (N + 1) + i, oo = 4 - groove(HS[j]);
    put(U.O + k, cx[i] + nx * oo, cy[i] + ny * oo, HS[j]); put(U.I + k, cx[i] - nx * 4, cy[i] - ny * 4, HS[j]);
  }
  for (i = 0; i <= N; i++) {
    var sx = Math.sin(tc[i]), sy = -Math.cos(tc[i]);
    put(U.B + 2 * i, cx[i] + sx * 4, cy[i] + sy * 4, 0); put(U.B + 2 * i + 1, cx[i] - sx * 4, cy[i] - sy * 4, 0);
    put(U.T + 2 * i, cx[i] + sx * 4, cy[i] + sy * 4, 220); put(U.T + 2 * i + 1, cx[i] - sx * 4, cy[i] - sy * 4, 220);
  }
  [0, N].forEach(function (ie, e) { var ex = Math.sin(tc[ie]), ey = -Math.cos(tc[ie]); for (j = 0; j < R; j++) { var q = U.E + e * 2 * R + 2 * j; put(q, cx[ie] + ex * (4 - groove(HS[j])), cy[ie] + ey * (4 - groove(HS[j])), HS[j]); put(q + 1, cx[ie] - ex * 4, cy[ie] - ey * 4, HS[j]); } });
  g.attributes.position.needsUpdate = true; g.computeVertexNormals(); g.computeBoundingSphere();
}

// the flat top: closes the roll inside the outer turn, with the socket hole over the hanging axis
function plateGeometry() {
  var M = 160, pos = [], idx = [], b = 20.5 / 360, i;
  for (i = 0; i <= M; i++) {
    var d = 360 * i / M, a = d * Math.PI / 180, r = (d <= 100 ? 50 + b * (d + 360) : 50 + b * d) - 3.5;
    pos.push((r * Math.cos(a) - CXH) / 100, 1.1, (r * Math.sin(a) - CYH) / 100, 0.21 * Math.cos(a), 1.1, 0.21 * Math.sin(a));
  }
  for (i = 0; i < M; i++) { var q = 2 * i; idx.push(q, q + 1, q + 2, q + 1, q + 3, q + 2); }
  var g = new THREE.BufferGeometry(); g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3)); g.setIndex(idx); g.computeVertexNormals(); return g;
}

function init(root) {
  if (!root || root.dataset.kgReady) return;
  root.dataset.kgReady = '1';
  var cv = root.querySelector('canvas');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var started = false;
  function start() {
    if (started) return; started = true;
    loadThree(root.dataset.three).then(function () { try { setup(); } catch (e) { console.error('kg-blatt', e); root.classList.add('kg-blatt--static'); } }, function () { root.classList.add('kg-blatt--static'); });
  }
  if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); }, { rootMargin: '600px 0px' }).observe(root); else start();

  function setup() {
    var gl; try { gl = new THREE.WebGLRenderer({ canvas: cv, antialias: true, alpha: false }); } catch (e) { root.classList.add('kg-blatt--static'); return; }
    gl.outputColorSpace = THREE.SRGBColorSpace; gl.toneMapping = THREE.NoToneMapping;
    gl.shadowMap.enabled = true; gl.shadowMap.type = THREE.VSMShadowMap;
    var scene = new THREE.Scene(); scene.background = new THREE.Color(PAPER);
    var cam = new THREE.PerspectiveCamera(22, 2, 0.1, 100);
    scene.add(new THREE.HemisphereLight(0xffffff, 0xe7e0d4, 1.0));
    var key = new THREE.DirectionalLight(0xfff8ee, 2.4); key.position.set(-5.5, 1.5, 4.0); key.castShadow = true;
    var small = Math.min(window.innerWidth, window.innerHeight) < 700;
    key.shadow.mapSize.set(small ? 1024 : 2048, small ? 1024 : 2048);
    var sc = key.shadow.camera; sc.left = -5; sc.right = 5; sc.top = 5; sc.bottom = -5; key.shadow.radius = 16; key.shadow.blurSamples = 24; key.shadow.bias = -0.0006;
    scene.add(key);
    var rim = new THREE.DirectionalLight(0xffffff, 0.6); rim.position.set(5, 2, -2); scene.add(rim);
    var mat = new THREE.MeshStandardMaterial({ color: new THREE.Color(root.dataset.color || '#485334'), roughness: 0.9, metalness: 0, side: THREE.DoubleSide, normalMap: skin(), normalScale: new THREE.Vector2(0.6, 0.6) });
    mat.shadowSide = THREE.DoubleSide;
    var geo = sheetGeometry(), mesh = new THREE.Mesh(geo, mat); mesh.castShadow = mesh.receiveShadow = true;
    var pmat = mat.clone(); pmat.transparent = true; pmat.opacity = 0;
    var plate = new THREE.Mesh(plateGeometry(), pmat); plate.castShadow = true;
    var cord = new THREE.Mesh(new THREE.CylinderGeometry(0.012, 0.012, 6, 10), new THREE.MeshStandardMaterial({ color: 0x1E1E1C, roughness: 0.6 }));
    cord.position.y = 4.1; cord.castShadow = true;
    var grp = new THREE.Group(); grp.add(mesh, plate, cord); scene.add(grp);
    var wall = new THREE.Mesh(new THREE.PlaneGeometry(60, 40), new THREE.ShadowMaterial({ opacity: 0.13, color: 0x2a2620 }));
    wall.position.z = -1.8; wall.receiveShadow = true; scene.add(wall);

    var e = reduce ? 1 : 0, mx = 0, tmx = 0, lastC = -1, raf = 0, visible = true, aspect = 2, w = 0, h = 0;
    function target() {
      if (reduce) return 1;
      var r = root.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = (vh - r.top) / (vh / 2 + r.height / 2); p = Math.min(1, Math.max(0, p));
      return p * p * (3 - 2 * p);
    }
    function size() {
      var r = root.getBoundingClientRect(); if (r.width < 2 || r.height < 2) return false;
      w = r.width; h = r.height; aspect = w / h;
      gl.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2)); gl.setSize(w, h, false);
      cam.aspect = aspect; cam.updateProjectionMatrix(); return true;
    }
    function draw() {
      var c = 0.3 + 0.7 * e;
      if (Math.abs(c - lastC) > 0.0005) { curl(geo, c); lastC = c; }
      var lid = Math.min(1, Math.max(0, (c - 0.94) / 0.06)); pmat.opacity = lid; plate.visible = lid > 0.01; cord.visible = lid > 0.5;
      var wide = aspect >= 1.1, half = Math.tan(11 * Math.PI / 180) * 10.9 * aspect;
      grp.rotation.y = 3.8 + (0.6 - 3.8) * e + mx * 0.45;
      grp.position.x = wide ? (0.2 + 0.2 * e) * half + 0.45 * (1 - e) : 0;
      var cy = 3.0 - 1.7 * e * e;
      if (wide) { cam.position.set(0, cy, 10.5); cam.lookAt(0, -0.1, 0); } else { cam.position.set(0, cy - 1.2, 15); cam.lookAt(0, -1.5, 0); }
      gl.render(scene, cam);
    }
    function tick() {
      raf = 0; if (!visible) return;
      var t = target(); e += (t - e) * (reduce ? 1 : 0.12); mx += (tmx - mx) * 0.08;
      draw();
      if (Math.abs(t - e) > 0.0005 || Math.abs(tmx - mx) > 0.0005) raf = requestAnimationFrame(tick);
    }
    function kick() { if (!raf && visible) raf = requestAnimationFrame(tick); }
    window.addEventListener('scroll', kick, { passive: true });
    if (!reduce) root.addEventListener('pointermove', function (ev) { var r = root.getBoundingClientRect(); tmx = (ev.clientX - r.left) / r.width - 0.5; kick(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); }).observe(root);
    var rt; function relayout() { clearTimeout(rt); rt = setTimeout(function () { if (size()) { root.classList.add('kg-blatt--live'); lastC = -1; kick(); } }, 120); }
    if ('ResizeObserver' in window) new ResizeObserver(relayout).observe(root); else window.addEventListener('resize', relayout);
    if (size()) { e = target(); root.classList.add('kg-blatt--live'); kick(); }
  }
}
function boot() { var l = document.querySelectorAll('.kg-blatt'); for (var i = 0; i < l.length; i++) init(l[i]); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();